export default {
      id: "oc-ai-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-ai",
      toString: function () {
        return this.url;
      }
    }